export class DgoAuth {
    data: any = {};

    constructor(params: any) {
        console.log('DgoAuth', params);
        this.data = {
            failureRedirect: params.failureRedirect ?? '',
            country: params.country ?? 'AR',
            response_type: params.response_type ?? 'code',
            redirect_uri: params.redirect_uri ?? '',
            state: params.state ?? '',
            client_id: params.client_id ?? 'iptel',
        };
    }
}